"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campospinoso-albaredo": {
    "cafd71e1": [{
      "hkey": "a0e5600f",
      "slug": "albaredo-arnaboldi",
      "name": "Albaredo Arnaboldi",
      "primary": true,
      "skipSearch": false
    }],
    "4c1d4ea2": [{
      "hkey": "c01ca0b9",
      "slug": "baselica",
      "name": "Baselica",
      "primary": true,
      "skipSearch": false
    }],
    "9a9b471b": [{
      "hkey": "68506c1f",
      "slug": "moranda",
      "name": "Moranda",
      "primary": true,
      "skipSearch": false
    }],
    "9d01281d": [{
      "hkey": "28404ef2",
      "slug": "campospinoso",
      "name": "Campospinoso",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;